import { useAssetUrl, BrandAssetType, BrandFavicon } from './useAsset.js';

function useHelmet(extendProps, headerProps) {
  var _extendProps$meta, _extendProps$htmlAttr, _headerProps$link, _extendProps$link, _extendProps$script;
  const getFaviconUrl = useAssetUrl(BrandAssetType.FAVICON);

  // Avoid duplication of meta description
  const extendedMeta = (_extendProps$meta = extendProps === null || extendProps === void 0 ? void 0 : extendProps.meta) !== null && _extendProps$meta !== void 0 ? _extendProps$meta : [];
  const meta = extendedMeta.some(meta => meta.name === 'description') ? extendedMeta : [...extendedMeta, {
    name: 'description',
    content: (headerProps === null || headerProps === void 0 ? void 0 : headerProps.description) || ''
  }];
  return {
    htmlAttributes: {
      ...((_extendProps$htmlAttr = extendProps === null || extendProps === void 0 ? void 0 : extendProps.htmlAttributes) !== null && _extendProps$htmlAttr !== void 0 ? _extendProps$htmlAttr : {})
    },
    meta: meta,
    link: [...((_headerProps$link = headerProps === null || headerProps === void 0 ? void 0 : headerProps.link) !== null && _headerProps$link !== void 0 ? _headerProps$link : [{
      rel: 'icon',
      type: 'image/png',
      sizes: '192x192',
      href: getFaviconUrl(BrandFavicon.ANDROID_CHROME_192)
    }, {
      rel: 'apple-touch-icon',
      sizes: '152x152',
      href: getFaviconUrl(BrandFavicon.APPLE_TOUCH_152)
    }, {
      rel: 'apple-touch-icon',
      sizes: '167x167',
      href: getFaviconUrl(BrandFavicon.APPLE_TOUCH_167)
    }, {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: getFaviconUrl(BrandFavicon.APPLE_TOUCH_180)
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href: getFaviconUrl(BrandFavicon.FAVICON_16)
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href: getFaviconUrl(BrandFavicon.FAVICON_32)
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '128x128',
      href: getFaviconUrl(BrandFavicon.FAVICON_128)
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '196x196',
      href: getFaviconUrl(BrandFavicon.FAVICON_196)
    }]), ...((_extendProps$link = extendProps === null || extendProps === void 0 ? void 0 : extendProps.link) !== null && _extendProps$link !== void 0 ? _extendProps$link : [])],
    title: (headerProps === null || headerProps === void 0 ? void 0 : headerProps.title) || '',
    script: [...((_extendProps$script = extendProps === null || extendProps === void 0 ? void 0 : extendProps.script) !== null && _extendProps$script !== void 0 ? _extendProps$script : [])]
  };
}

export { useHelmet };
//# sourceMappingURL=useHelmet.js.map
